import { Button, Col, Image, Row } from "antd";
import { createUseStyles } from "react-jss";
import svgUrl from "assets/maintenance.svg";
import { Colors } from "utils/colors";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectDownTime } from "store/maintenance/maintenanceSelector";

const useStyles = createUseStyles({
  content: {
    height: "100vh",
    width: "100%",
    paddingBottom: "32px",
    bottom: 0,
    alignItems: "center",
    backgroundColor: Colors.lightBlue1,
    background: `linear-gradient(0deg, ${Colors.lightGreen} 42%, ${Colors.lightBlue2} 49%, ${Colors.lightBlue3} 57%)`,
    "& div": {
      width: "100%",
    },
    "& img": {
      height: "80vh",
      right: 0,
      top: 0,
      backgroundSize: "auto",
    },
    "& button": {
      borderRadius: "16px",
      minWidth: "120px",
      height: "32px",
      backgroundColor: Colors.blue,
      color: Colors.white,
      "&:hover": {
        backgroundColor: Colors.blue,
        color: Colors.white,
      },
      "&:active": {
        backgroundColor: Colors.blue,
        color: Colors.white,
      },
    },
  },
});

const SystemMaintenancePage = () => {
  const classes = useStyles();
  const downtime = useSelector(selectDownTime);

  useEffect(() => {
    setTimeout(() => {
      window.location.reload();
    }, 30000);
  });

  const onClick = () => {
    window.location.reload();
  };

  return (
    <>
      <Row justify="center" align="middle" className={classes.content}>
        <Col span={24}>
          <Image src={svgUrl} preview={false} data-type="maintenance" />
        </Col>
        {!!downtime && (
          <Col
            span={24}
            style={{
              textAlign: "center",
              paddingLeft: "16px",
              paddingRight: "16px",
              fontWeight: "normal",
            }}
          >
            <span style={{ whiteSpace: "pre-line" }}>{downtime}</span>
          </Col>
        )}
        <Col span={24} style={{ textAlign: "center" }}>
          <Button data-type="btn-refresh" onClick={onClick}>
            Refresh
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default SystemMaintenancePage;
